import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
import StudyList from "../../components/Study/StudyList";
import { useLocation, Link } from "react-router-dom";
import "./StudyListPage.css";
import CSVImportModal from "../../components/CSVImportModal";

const StudyListPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const patientId = searchParams.get("patient");
  let createLink = `/studies/create`;
  if (patientId) createLink += `?patient=${patientId}`;

  const [isModalOpen, setModalOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const downloadTimeoutRef = useRef(null);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const handleRefresh = () => setRefreshData((prev) => prev + 1);

  useEffect(() => {
    console.log("Selected Studies:", selectedIds);
  }, [selectedIds]);

  const handleDownload = async () => {
    if (selectedIds.length === 0) {
      alert("Please select at least one study to download");
      return;
    }
    if (downloadInProgress) {
      return;
    }
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
    }
    
    downloadTimeoutRef.current = setTimeout(async () => {
      setDownloadInProgress(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/patients/studies/download`,
          {
            params: { 
              id: selectedIds.join(","),
              onlyCsv: true
            },
            headers: { Authorization: `Token ${token}` },
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        
        const timestamp = new Date().toISOString().replace(/[:.]/g, "").substring(0, 15);
        const filename = `studies_${timestamp}.csv`;
        link.setAttribute("download", filename);
        
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading studies:", error);
        alert("Error downloading studies. Please try again.");
      }
      setDownloadInProgress(false);
    }, 300);
  };

  return (
    <div className="study-list-page">
      <Navbar />
      <div className="study-list-content">
        <div className="study-header-section">
          <h2>Studies</h2>
          <div className="button-group">
            <Link to={createLink} className="study-create-btn-main">
              New Study
            </Link>
            <button className="csv-import-btn" onClick={openModal}>
              CSV Import
            </button>
            <button
              className="download-btn"
              onClick={handleDownload}
              disabled={selectedIds.length === 0 || downloadInProgress}
            >
              Download Selected ({selectedIds.length})
            </button>
          </div>
        </div>
        <StudyList refreshData={refreshData} onSelectedIdsChange={setSelectedIds} />
      </div>

      <CSVImportModal
        type={"studies"}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSuccess={() => {
          handleRefresh();
          closeModal();
        }}
      />
    </div>
  );
};

export default StudyListPage;
